import React, { useEffect } from 'react';
import { useApi } from '@axiom/ui';
import { useNavigate, useParams } from 'react-router';

import { isClientUser } from '../../utils/roles-util';
import { UserApi } from '../../api/user-api';
import { AccountReassignmentNotification } from '../AccountReassignmentNotification/AccountReassignmentNotification';

export const MyEngagementsRedirectClientUser = () => {
  const [{ data: user }] = useApi(UserApi.readUser());
  const navigate = useNavigate();
  const { accountId: urlAccountId } = useParams();

  useEffect(() => {
    if (!urlAccountId && isClientUser(user)) {
      const accountId = user.contact?.accounts?.[0]?.id ?? null;

      if (accountId) {
        void navigate(`./${accountId}`, { replace: true });
      }
    }
  }, []);

  return (
    <div data-test="CLIENT_ENGAGEMENTS">
      <AccountReassignmentNotification
        user={user}
        urlAccountId={urlAccountId}
      />
    </div>
  );
};
